import React from 'react';
import { Currency, DateTime } from '~/components';
import { BulkActionModal } from '~/components/bulk-action';
import { useApi, useWorkspace } from '~/contexts';

export default function BulkDelete({ projectId, ids, currency, onClose, onComplete }) {
  const { workspace } = useWorkspace();
  const api = useApi();

  const renderRow = ({ productItem }) => (
    <>
      <DateTime value={productItem.date} /> &middot; {productItem.invoiceItem?.name} &middot;{' '}
      <Currency value={productItem.fee} currency={currency} />
    </>
  );

  return (
    <BulkActionModal
      title="Delete Products"
      variant="delete"
      onClose={onClose}
      onComplete={onComplete}
      onConfirm={() =>
        api.www
          .workspaces(workspace.id)
          .projectSettings(projectId)
          .products()
          .bulkDelete(ids)
          .then((r) => r.data)
      }
      renderRow={renderRow}>
      {`This will delete ${
        ids.length === 1 ? 'the selected product' : `the ${ids.length} selected products`
      }. Invoiced items will be skipped. This action cannot be undone.`}
    </BulkActionModal>
  );
}
